import React from 'react'
import styles from './ActiveGamesRow.module.css';
// import MiniGameTable from '../MiniGameTable/MiniGameTable';
import { MiniGameTable } from '@themed-components';
// import AddGameTableDialog from '../MiniGameTable/AddGameTableDialog';
import { AddGameTableDialog } from '@themed-components';

export default function ActiveGamesRow({ activeGames, activeGame }) {
    return (
        <div className={styles.activeGamesRowContainer}>
            {
                activeGames.map((game) => (
                    <MiniGameTable key={'MiniGameTable-' + game} tempTableId={game} />
                ))
            }
            {
                activeGames.length < 4 ?
                    <AddGameTableDialog activeGame={activeGame} /> : null
            }
        </div>
    )
}
